import { reactive } from 'vue';

export const geoPaymentMethodsFormRules = reactive({
  publicName: [
    { required: true, message: 'Public name is required', trigger: 'blur' },
    {
      validator: (_, value, callback) =>
        ((value && value.trim().length === 0) ? callback(new Error('Public name is required')) : callback()),
      trigger: 'blur',
    },
  ],
});
